import React, { useState,useEffect } from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { Table, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { doGetAuditorContractList,isEdit,addAuditor} from './actions/auditorService'
import Cookie from 'js-cookie';
import AuditorContractMapping from './AuditorContractMapping';
import AuditorContractMappingEdit from './AuditorContractMappingEdit';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { Config } from '../../config/config';
import { useNavigate } from 'react-router-dom';
import LZString from 'lz-string';
const { Option } = Select;

const AuditorContract = () =>{
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
    const userID = user['userId'];
    const config = JSON.parse(Config);
    const apiInterface = config['api1']
    const status = useSelector(state =>state?.auditorList )
    const auditorContractList = useSelector(state => state?.auditorList?.AuditorContractDetails)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [editData, setEditData] = useState([]);
    const title= "Auditor Contract"
    const filterParams = ["zone", "state", "projectScopesId", "auditorId", "storeId"]; // zone, state, projectScopesId, auditorId, storeId
    const message =''
    const modalOpen =false
    const [tableData, setTableData] = useState()
    const [searchedItem, setSearchedItem] = useState({
        zone: [],
        state: [],
        projectScopesId: [],
        id: null,
        storeId : null
    })
    const TableColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render:  (text, record) => (
                <Space size="middle">
                    <div className="table-icons">
                        <i className="fa fa-pencil blue" onClick={()=>_doEditAuditor(record)} aria-hidden="true"></i>
                    </div>
                </Space>
            ),
        },
        {
            title : 'Auditor Name',
            dataIndex:'auditorName',
            key:"auditorName"
        },
        {
            title: "Contract start date",
            width:140,
            dataIndex: "contractStartDate",
            key: "contractStartDate"
        },
        {
            title: "Contract end date",
            width:140,
            dataIndex: "contractEndDate",
            key: "contractEndDate"
        },
        {
            title: "Download Document",
            dataIndex: "contractFileName",
            key: "contractFileName",
            render:  (text, record) => (
                <Space size="middle">
                    <div className="table-icons" style={{cursor:'pointer'}}>
                        <i className="fa fa-file-text" onClick={()=>handleDownload(record)} aria-hidden="true"></i>
                    </div>
                </Space>
            ),
        },
    ]
    const handleDownload = (ele) =>{
        if(ele.contractFileName)
            window.location.href = `${apiInterface}/downloadfiles?Image_id=${ele.contractFileName}&token_id=${Cookie.get('token')}`
    }
    const _doEditAuditor=(data)=>{
        //CAUTION: this code will working only when Store Names are uniques as store names are mapped back to ids while submit
        //insert store names instead of ids
        data.storeId = data.storeId.split(',');
        let tempStoreNames = auditorContractList?.StoreList.map((store)=> {
            return data?.storeId?.map((storeId)=> {
              if(storeId == store.storeId)
                return store.storeName
            })
          })
        data.storeNames = tempStoreNames.flat().filter(item => item != undefined);
        //CAUTION: same as above
        data.projectScopesId = data.projectScopesId.split(',');
        let tempProjectScopes = auditorContractList?.ProjectScopes.map((projectScope)=> {
            return data?.projectScopesId?.map((projectScopesId)=> {
              if(projectScopesId == projectScope.id)
                return projectScope.name
            })
          })
        data.projectScopes = tempProjectScopes.flat().filter(item => item != undefined);
        setEditData(data)
        dispatch(isEdit(true))
    }
    const _doNavToAuditorContract = () => {
        dispatch(addAuditor(true))
        navigate("/AuditorContractMapping");
        setSearchedItem({
            zone: [],
            state: [],
            projectScopesId: [],
            auditorId: null,
            storeId : null
        })
        setTableData(auditorContractList?.AuditorsContractMappingList)
    };
    useEffect(() => {
        dispatch(doGetAuditorContractList())
    }, [])
    useEffect(() => {
        //as we do not maintain an alternate copy of contractList we need to fetch data again
        if(status?.isAuditorList)
            dispatch(doGetAuditorContractList())
    }, [status?.isAuditorList]) 
    useEffect(() => {
        if(searchedItem.zone.length!=0 || searchedItem.state.length !=0 ||searchedItem.projectScopesId.length!=0 || searchedItem.auditorId || searchedItem.storeId){
            handleSearch();
        }else{
            setTableData(auditorContractList?.AuditorsContractMappingList)
        }
    }, [auditorContractList])
    
    const handleSearch = () => {
        if(searchedItem.state.length ==0 && searchedItem.projectScopesId.length==0 && searchedItem.zone.length==0 && !searchedItem.auditorId && !searchedItem.storeId ){
            setTableData(auditorContractList?.AuditorsContractMappingList)
        }
        else {
            let result =  filterRecursively(filterParams[0], 0);
            bfirstRecursionCompleted = false;
            setTableData(result);
        }
    }
    let filteredResult = [];
    let bfirstRecursionCompleted = false;
    let filterStatus = Array(5).fill(0);
    const filterRecursively = (filterParam, index) =>{
    if(index == filterParams.length)
        return filteredResult;
    let searchItem = searchedItem[filterParam];
    if(searchItem != null || ( Array.isArray(searchItem) && searchItem.length)){
        for (let j = 0; j < auditorContractList?.AuditorsContractMappingList.length; j++) {
            let contract = auditorContractList?.AuditorsContractMappingList[j][filterParam];
            if(typeof contract =='number'){
                contract = contract.toString();
            }
            if(Array.isArray(searchItem)){
                searchItem = searchItem.map(item => item.toString())
            }
            if(bfirstRecursionCompleted && filteredResult.length){
            filteredResult.map((ele, i)=> {
                if(((!Array.isArray(searchItem) && (ele[filterParam]).toString().includes(searchItem)) || (Array.isArray(searchItem) && searchItem.length && !ele[filterParam].split(',').some(item => searchItem.includes(item))))){
                //remove if searched item is not present for that particular parameter in already filtered Array.
                filteredResult.splice(i, 1);
                }
            })
            }
            else if(!bfirstRecursionCompleted && ((!Array.isArray(searchItem) && contract.includes(searchItem)) || (Array.isArray(searchItem) && searchItem.length && contract.split(',').some(item =>   searchItem.includes(item))))){
            filterStatus[index] = 1;
            filteredResult.push(auditorContractList?.AuditorsContractMappingList[j]);
            }
        }
    }
    if(!bfirstRecursionCompleted || filteredResult.length !=0){
        if(filterStatus[index]) bfirstRecursionCompleted = true; //first iteration after filteredResult is filled 
        return filterRecursively(filterParams[index+1], index+1)
    }
    }
    return ( 
        <>
           {status?.isAuditorList?   <>
           {modalOpen?(
               <MessageBox 
                message = {message}
                signout = {false}
                // onClose = {handleClose}
               />
           ):null}
          <Header title={title} />
            <Menu />

            <div className='content-wrapper'>
                {status?.loading?(<Spinner/>):(<>
                <div className="m-btn-block">
                    <div className="m-btn-block__container">
                        <div className="m-btn-block__icon">
                            <i className="fa fa-plus-circle" aria-hidden="true"></i>
                        </div>
                        <div className="m-btn-block__btns">
                            <button type='submit' onClick={_doNavToAuditorContract} className='btn btn-secondary deca-btn-yellow'>Contract Mapping</button>
                        </div>
                    </div>
                </div>
                <section className='content'>
                    <div className="m-panel mt-10">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className='form-group'>
                                        <label htmlFor='exampleInput'>Auditor</label>
                                        <Select className="form-control"
                                                showSearch
                                                allowClear={true}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                onChange={(value) => {setSearchedItem({ ...searchedItem, auditorId: value?.toString() }) }}
                                                value={searchedItem.auditorName}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >{
                                                    auditorContractList?.AuditorNameList?.map(item=>(
                                                        <Option key={item.id} value={item.id}>{item.auditorName}</Option>
                                                    ))
                                                }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className='form-group select_h150'>
                                        <label htmlFor='exampleInput'>select zone</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            mode='multiple'
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            onChange={(value) => { setSearchedItem({ ...searchedItem, zone: value}) }}
                                            value = {searchedItem.zone}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {
                                                auditorContractList?.ZoneList.map((item)=>(
                                                    <Option key={item.codeId} value={item.codeId}>{item.codeValue}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className='form-group select_h150'>
                                        <label htmlFor='exampleInput'>select state</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            mode='multiple'
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            onChange={(value) => { setSearchedItem({ ...searchedItem, state: value }) }}
                                            value = {searchedItem.state}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {
                                                auditorContractList?.StateList.map((item)=>(
                                                    <Option key={item.codeId} value={item.codeId}>{item.codeValue}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className='form-group select_h150'>
                                        <label htmlFor='exampleInput'>Select Project Scope</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            mode='multiple'
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            onChange={(value) => { setSearchedItem({ ...searchedItem, projectScopesId: value }) }}
                                            value = {searchedItem.projectScope}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {
                                                auditorContractList?.ProjectScopes.map((item)=>(
                                                    <Option key={item.id} value={item.id}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className='form-group'>
                                        <label htmlFor='exampleInput'>Stores</label>
                                        <Select className="form-control"
                                                showSearch
                                                allowClear={true}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                onChange={(value) => {setSearchedItem({ ...searchedItem, storeId: value?.toString() }) }}
                                                value={searchedItem.storeName}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >{
                                                    auditorContractList?.StoreList?.map((item,index)=>(
                                                        <Option key={index} value={item.storeId}>{item.storeName}</Option>
                                                    ))
                                                }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-1 btn-no-lbl">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick = {handleSearch}>
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="m-table__main">
                                <div className="m-table__responsive medium-width has-action-column single">
                                    <Table columns={TableColumns} dataSource={tableData} />
                                </div>
                            </div>
                        </div>
                    </div>                   
                </section></>)}
                
            </div>
            </>:null}
            {
             status?.isAuditorCreate?<AuditorContractMapping />:null   
            }
            {
             status?.isAuditorEdit?<AuditorContractMappingEdit Editdata={editData} />:null   
            }
            <Footer />
        </>
    )
}
export default AuditorContract